import styled from "@emotion/styled";
import { Body, Title } from ".";
import { Spacer } from "components/general/Spacer/Spacer";
import { SadBopStatic } from "components/general/SadBopStatic";

// Shown when fetching trade history is not successful
export const ErrorDisplay = () => {
  return (
    <Wrapper>
      <Container>
        <SadBopStatic />
        <Spacer height="22px" />
        <Title>Something went wrong.</Title>
        <Body>Please try again. If the problem persists you can contact us.</Body>
      </Container>
    </Wrapper>
  );
};

// Sub-components

const Wrapper = styled.div`
  width: 100%;
  margin: auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
  margin: auto;
`;
